import React, { FC, useState, useEffect, useRef, Ref } from 'react';
import { InputProps } from './props';
import { Container } from './styles';
import styled from 'styled-components';

// @TODO: customize
const StyledInput = styled.input<InputProps>`
    width: 100%;
`;

export const InputFile: FC<InputProps> = ({
    label,
    color = '#47516f',
    isValid,
    style,
    value,
    onChange,
    ...rest
}) => {
    const ref: Ref<HTMLInputElement> = useRef(null); 
    const [text, setText] = useState(value || '');
    const [focused, setFocused] = useState(false);

    useEffect(() => {
        if (ref.current) {
            ref.current.onfocus = () => setFocused(true);
            ref.current.onblur = () => setFocused(false);
        }
    }, [ref]);

    useEffect(() => {
        setText(value || '');
    }, [value]);

    return (
        <Container style={style}>
            <StyledInput
                {...rest}
                isValid={isValid}
                type='file'
                value={text}
                ref={ref}
                onChange={(ev: any) => {
                    setText(ev.target.value);
                    return onChange?.(ev);
                }}
                placeholder=''
            />
        </Container>
    );
};
